import React from 'react';
import { PartnersList } from '../../components';
import styled from 'styled-components';

const Partners = () => {
  return (
    <StyledPartners>
      <PartnersTitle>Уже доступно в 4000+ локациях Москвы</PartnersTitle>
      <PartnersList />
    </StyledPartners>
  );
};

const StyledPartners = styled.section`
  background-color: #e7e8eb;
`;

const PartnersTitle = styled.h2`
  font-weight: 600;
  font-size: 20px;
  color: #606872;
  margin-top: 64px;
  text-align: center;
`;

export default Partners;
